module.exports = __webpack_public_path__ + "img/bg001.3f02af62.svg";